import styles from './list.module.scss';
import React from 'react';

interface OwnProps {
    children: React.ReactNode;
}

export function List({children}: OwnProps) {
    return <ul className={styles.list}>{children}</ul>;
}
